import { useState } from "react";
import Icon from "../../../components/base/Icon";
import { toastSuccess } from "../../../components/base/Toast";
import Form from "../../../components/form/Form";
import TextBox from "../../../components/form/TextBox";
import Tagify from "../../../components/tagify/Tagify";
import { API_ROUTES } from "../../../core/Constants";
import { getUser, useHub } from "../../../core/Global";
import UserGroup from "../models/UserGroup";


interface IProps {
    model: UserGroup
    onUpdate?: (group: UserGroup) => void
}

export default function UserGroupEdit(props: IProps) {

    const hub = useHub();
    const user = getUser();
    const [working, workingSet] = useState<boolean>(false);

    return (
        <Form id="form-usergroup-edit" className="form"
            onSubmit={(body, callback) => {

                var valid = true;

                if (user?.isSuperAdmin) {
                    if (window.isNullOrEmpty(body.ownerUserId)) {
                        window.formError("ownerUserId", "Please choose the assignee user!", "form-usergroup-edit");
                        valid = false;
                    }
                }

                if (!body.name || body.name == "" || body.name.length < 2) {
                    window.formError("name", "Please write a valid name!", "form-usergroup-edit");
                    valid = false;
                }

                if (!valid) {
                    if (callback) callback();
                    return;
                }

                workingSet(true);
                hub.Put(API_ROUTES.UsersGroups + props.model.id, body, res => {
                    workingSet(false);
                    if (res.success) {
                        toastSuccess("Group has been saved successfully!");
                        if (props.onUpdate) props.onUpdate(res.data);
                    }
                    if (callback) callback(res);
                })

            }}>
            <div className="card">
                <div className="card-header border-0">
                    <h3 className="card-title">
                        <span className="card-label fw-bolder text-dark">Edit Group</span>
                    </h3>
                    <div className="card-action">
                        <button type="submit" className="btn btn-sm btn-primary" disabled={working}>
                            {
                                working ?
                                    <>
                                        <Icon icon="spinner-third" spin />
                                        <span className="ms-2">Updating...</span>
                                    </>
                                    :
                                    <>Update Group</>
                            }
                        </button>
                    </div>
                </div>
                <div className="card-body border-top pt-9 pb-9" style={{ maxWidth: 800 }}>

                    {
                        user?.isSuperAdmin &&
                        <>
                            <div className="fs-7 fw-bolder">
                                Assign to
                                <span id="ownerUserId-err" className="small text-danger mx-2 form-error"></span>
                            </div>
                            <Tagify name="ownerUserId" id="drp-usergroup-edit-ownerUserId" placeholder="Select a Customer"
                                apiUrl={API_ROUTES.TagifyCustomers} single block selectedId={props.model.ownerUserId} />
                        </>
                    }

                    <TextBox id="txt-usergroup-edit-name" name="name"
                        labelUp label="Group Name" block value={props.model.name}
                        placeholder="E.g. Administrators, Managers, Agents, etc" />

                </div>
            </div>
        </Form>
    )
}
